module.exports = __webpack_public_path__ + "static/img/background.2a7fc244.svg";